import { Euler } from 'three';

import { DEFAULT_MOTION_SCENE_CHARACTER_ROTATION } from '../../../shared/motionScene';
import { MOTION_EDITOR_RESOURCE_DOMAIN } from '../resources';

interface MotionEditorDefaultCharacter {
  heroThumbnailPath: string;
  jobID: string;
  jointJsonPath: string;
  meshPath: string;
  thumbnailPath: string;
  rotationOffsets?: undefined;
}

const NO_CHARACTER_ROTATION = new Euler(0, 0, 0);

function isDefaultMotionEditorCharacterCreatedBy(createdBy: string) {
  return createdBy.startsWith('FREE_CHARACTERS');
}

export function resolveIsDefaultMotionEditorCharacter({
  createdBy,
}: {
  createdBy?: string;
}) {
  return createdBy != null && isDefaultMotionEditorCharacterCreatedBy(createdBy);
}

export function getMotionEditorCharacterRotation(isDefaultCharacter: boolean) {
  return isDefaultCharacter ? DEFAULT_MOTION_SCENE_CHARACTER_ROTATION : NO_CHARACTER_ROTATION;
}

export const DEFAULT_CHARACTER: MotionEditorDefaultCharacter = {
  jobID: 'char-upload-Axel',
  heroThumbnailPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/hero-thumbnail.png`,
  jointJsonPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/character.json`,
  meshPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/character.glb`,
  thumbnailPath: `${MOTION_EDITOR_RESOURCE_DOMAIN}/character-uploads/FREE_CHARACTERS/char-upload-Axel/thumbnail.png`,
};
